import { defineStore } from 'pinia'
import { ref } from 'vue'
import { encryptData, decryptData } from '~/composables/useEncrypt'

type UserInfo = {
  result: boolean;
  userAccount: string;
  userMail: string;
  name: string;
  firstName: string;
  lastName: string;
  userToken: string;
  imageUrl: string;
  userCountry: number;
  // Address related fields for profile form
  postcode?: string;
  city?: string;
  addressLine1?: string;
  addressLine2?: string;
}

type EncryptedData = string;

type DecryptedData = {
  data: UserInfo
}

export const useUserInfoStore = defineStore('userInfo', () => {
  const config = useRuntimeConfig();
  const userInfo = ref('')
  
  const getUserDetail = async (token: string) : Promise<UserInfo | undefined>=> {
    try {
      const res = await $fetch<UserInfo>(`${config.public.APIurl}/api/v3/user`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
      })
      return res
    }catch(error) {
      throw error;
    }
  }

  const setUserInfo = async(token: string) => {
      const userdata = await getUserDetail(token)
      userInfo.value = encryptData({
        data: userdata
      })
  }
  const getUserInfo = (): UserInfo | null => {
    if(userInfo.value !== ""){
      const userdata = decryptData(userInfo.value) as DecryptedData;
      return userdata.data
    }
    return null;
  }

  const clearUserInfo = () => {
    userInfo.value = ""
  }

  return { userInfo, getUserDetail, setUserInfo, getUserInfo, clearUserInfo }
},  {
  persist:import.meta.client && {
    storage: localStorage
  }
})
